/**
 * Verifies an entered password against an AES-encrypted stored value.
 * Uses dynamic import to keep password-encryption.ts server-only.
 * @param entered - The plaintext password the user entered
 * @param stored - The stored AES-encrypted password
 * @returns True if the password matches
 */
export async function verifyPassword(entered: string, stored: string): Promise<boolean> {
  const { decryptPassword } = await import("@/lib/utils/password-encryption");
  const decrypted = await decryptPassword(stored);
  return decrypted !== null && entered === decrypted;
}
